export default __webpack_public_path__ + "static/og-image-87ff9aa38330b104bba8fa12a77fb2c2.jpg";